import { render } from "./UiPropMediaPicker.vue?vue&type=template&id=2986b22c"
import script from "./UiPropMediaPicker.vue?vue&type=script&lang=js"
export * from "./UiPropMediaPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__